// global.BaseUrl =
//   "https://foodweb-antelope.ksoftpl.com/avenue-uptown-6/public/api";
// global.AssetsUrl =
//   "https://foodweb-antelope.ksoftpl.com/avenue-uptown-6/public";

global.BaseUrl = "https://admin.foodweb-antelope.ksoftpl.com/api";
global.AssetsUrl = "https://admin.foodweb-antelope.ksoftpl.com";
